import React, {useState} from "react";
import {p0, p1, p2, p4, p8, p16, p32} from "../../pl_commons";
import PlIcon from "../pl_icon";
import {baseline, bm_left, bm_right} from "./icon_commons";


const SgIcon = ({item, startsignal, onClick}) => {


    const select = startsignal === item.id

    const [eset, setEset] = useState(false);
    const [wset, setWset] = useState(false);


    function doClick(val) {
        onClick(val)
    }

    function doClickE(val) {
        onClick('east')
        setEset(true);
        setWset(false);
    }

    function doClickW(val) {
        onClick('west')
        setEset(false);
        setWset(true);
    }

    const [areaW, setAreaW] = useState(false)
    const [areaE, setAreaE] = useState(false)

    function areaEnter(val, area) {
        if( area ) {
            if (area === 'E') {
                setAreaE(val)
            } else if (area === 'W') {
                setAreaW(val)
            }
        } else {
            setAreaE(val)
            setAreaW(val)
        }
    }

    let bmstate = item.fbstat === "true"

    let intbm = {}
    intbm.state = bmstate
    intbm.lcid = item.lcid || ''

    const route_east = item.lockdir === "east"
    const route_west = item.lockdir === "west"
    const route_set = (route_east || route_west) //&& stbitem && stbitem.lockid !== ""
    const bm_set = item.fbstat === "true"

    let rtcolor = '#777777';
    let rtxcolor = '#777777';

    let inroute = item.lockdir === "east" || item.lockdir === "west"

    if (inroute) {
        rtcolor = '#fff44f';
    }

    if (bmstate ) {
        rtcolor = '#ff0000';
    }

    const schirmcolor = '#444444'
    const sgred = '#f23a37'
    const sggreen = '#60d539'
    const sgoff = '#000000'

    let line = baseline()
    let line2 = bm_left({stroke: rtcolor})
    let line3 = bm_right({stroke: rtcolor})



    var searchcolor = "rgba(0,0,0,0)";
    let searchblink;
    if (item.blink || item.blink === "true") {
        searchcolor = "#ab274e";
        searchblink = <animate
            attributeType="XML"
            attributeName="fill"
            values="#b2b2b2;#b2b2b2;#ab274e;#ab274e;"
            dur="1s"
            repeatCount="indefinite"/>
    }
    var searchbubble = <circle key="csearch" cx={p1 - p16} cy={p1 - p16} r={p16}
                               fill={searchcolor}>{searchblink}</circle>;

    var autosgcolor = "rgb(0,0,0)";

    //console.log(item)
    let autosg = item.autosg || item.autosg === 'true'

    var autonextcolor = "rgb(159,19,175)";
    var autonextbubble = autosg ?
        <>
            <circle key="cautonextb" cx={p1 - p8} cy={p1 - p16 - 1} r={p16} fill={'#000000'}/>
            <circle key="cautonextb1" cx={p1 - p8} cy={p1 - p16 - 1} r={p16 - 1} fill={autonextcolor}/>
        </> : null;


    let transformt = "rotate(0,0,0)";
    let xt=p8, yt=p4
    if (item.ori === "east") {
        transformt = 'rotate(180,'+xt+', '+yt+') translate('+(-p2-p8)+','+(p8+p32)+')';
    } else {
        transformt = 'rotate(0,'+xt+', '+yt+') translate('+(p8)+','+(p16)+')';
    }
    let txt = <a></a>

    let transform = "rotate(0,0,0)";

    const lringenter = '#e8ef3d'


    let itemstate = item.accstate;
    let itemstate_e = item.accstate_e;
    let itemstate_w = item.accstate_w;

    //if( !item.addr || item.addr === "") {
        itemstate = item.virtual_state
    //}
    if( !item.addr_e || item.addr_e === "") {
        itemstate_e = item.virtual_state_e
    }
    if( !item.addr_w || item.addr_w === "") {
        itemstate_w = item.virtual_state_w
    }

    var lights2 = []
    var clickarea = []

    if (item.subtype === "shunt") {
        const east = item.ori === 'east'

        var lights1 = [];

        //line3 = east ? line3 : line3
        //line2 = east ? null : null

        const dxx = 0 //+ (east?0:-p8-p16)

        const dx = 0; //p4+p8 + dxx;
        const dy = 0; //p2+p8;
        const path = 'M ' + (p8 + dx) + ' ' + (0 + dy) + ' L ' + (0 + dx) + ' ' + (p8 + dy) + ' L ' + (0 + dx) + ' ' + (p4 + dy) + ' L ' + (p4 + dx) + ' ' + (p4 + dy) + ' L ' + (p4 + dx) + ' ' + (0 + dy) + ' Z'

        //console.log('PATH ' + path)

        const sg0col = sgoff // sgred

        if (item.shunt_sg_east || item.shunt_sg_east === 'true') {
            let transformz = 'rotate(180,' + p8 + ',' + p8 + ') translate(' + (-p2 + p16) + ',' + (-p8) + ')';
            lights1.push(
                <path key={'shunt_sg_east_sch'} d={path} fill={schirmcolor} transform={transformz}/>
            )
            lights1.push(<circle key="c2"
                                 cx={p2 + p16}
                                 cy={p4}
                                 r={(p4) / 5}
                                 fill={(itemstate_e && itemstate_e !== 0) ? sggreen : sg0col}/>);
            lights1.push(<line
                key={"lx1"}
                x1={p4 + p8}
                y1={p4}
                x2={p2}
                y2={p4}
                stroke={"#525252"}
                strokeWidth={p32}
                strokeLinecap="round"/>);
        }
        if (item.shunt_sg_west || item.shunt_sg_west === 'true') {
            let transformz = 'rotate(0,' + p8 + ',' + p8 + ') translate(' + (p2 - p16) + ',' + (p2 + p8) + ')';
            lights1.push(
                <path key={'shunt_sg_west_sch'} d={path} fill={schirmcolor} transform={transformz}/>
            )
            lights1.push(<circle key="cvgt9862"
                                 cx={p2 + p16}
                                 cy={p2 + p4}
                                 r={(p4) / 5}
                                 fill={(itemstate_w && itemstate_w !== 0) ? sggreen : sg0col}/>);
            lights1.push(<line
                key={'lx1r5'}
                x1={p1 - p4}
                y1={p1 - p4}
                x2={p2 + p8}
                y2={p1 - p4}
                stroke={"#525252"}
                strokeWidth={p32}
                strokeLinecap="round"/>);
        }

        if (item.shunt_button_east === true || item.shunt_button_east === 'true') {
            const lring = '#9f9f9f'
            const dxx2 = 0;

            lights1.push(<circle key="c3"
                                 cx={p1 - p4 + dxx2}
                                 cy={p2}
                                 r={(p4) / 2}
                                 fill={lring}/>);
            lights1.push(<circle key="c4"
                                 cx={p1 - p4 + dxx2}
                                 cy={p2}
                                 r={(p4) / 2 - p32}
                                 fill={(areaE) ? lringenter : '#575757'}/>);
            lights1.push(<circle key="c5"
                                 cx={p1 - p4 + dxx2}
                                 cy={p2}
                                 r={(p4) / 2 - p16}
                                 fill={select && eset ? '#d5d3a4' : lring}/>);

            // Click area
            clickarea.push(
                <rect key={'rxx'} x={p2} y={0} width={p2} height={p1} fillOpacity={0} onClick={doClickE}
                      onMouseEnter={() => areaEnter( true, 'E')} onMouseLeave={() => areaEnter(false, 'E')}/>
            )
        }

        if (item.shunt_button_west === true || item.shunt_button_west === 'true') {
            const lring = '#3d88c9'
            const lcenter = '#9f9f9f'

            const dxx2 = -p2

            lights1.push(<circle key="c32"
                                 cx={p1 - p4 + dxx2}
                                 cy={p2}
                                 r={(p4) / 2}
                                 fill={lring}/>);
            lights1.push(<circle key="c42"
                                 cx={p1 - p4 + dxx2}
                                 cy={p2}
                                 r={(p4) / 2 - p32}
                                 fill={(areaW) ? lringenter : '#575757'}/>);
            lights1.push(<circle key="c52"
                                 cx={p1 - p4 + dxx2}
                                 cy={p2}
                                 r={(p4) / 2 - p16}
                                 fill={(select && wset) ? '#d3cd2f' : lcenter}/>);

            // Click area
            clickarea.push(
                <rect key={'rxxfv'} x={0} y={0} width={p2} height={p1} fillOpacity={0} onClick={doClickW}
                      onMouseEnter={() => areaEnter(true, 'W')} onMouseLeave={() => areaEnter(false, 'W')}/>
            )
        }

    } else if (item.subtype === "bauf") {
        line = null
        line2 = null
        line3 = null
        var lights1 = [];

        const lring = '#a21010'
        lights1.push(<circle
            key="c1"
            cx={p2}
            cy={p4}
            r={(p4) / 2}
            fill={lring}/>);
        lights1.push(<circle key="c2"
                             cx={p2}
                             cy={p4}
                             r={(p4) / 2 - p32}
                             fill={(areaE||areaW) ? lringenter : '#575757'}/>);
        lights1.push(<circle
            key="c3"
            cx={p2}
            cy={p4}
            r={(p4) / 2 - p16}
            fill={select ? '#d5d3a4' : lring}/>);

        lights1.push(
            <text key="t0bauf" x={p4} y={p2 + p4} fontSize={7} fontFamily={'monospace'}>BAuF</text>
        )

        // Click area
        clickarea.push(
            <rect key={'rxx'} x={0} y={0} width={p1} height={p1} fillOpacity={0} onClick={() => doClick('bauf')}
                  onMouseEnter={() => areaEnter(true)} onMouseLeave={() => areaEnter(false)}/>
        )


    } else if (item.subtype === "main" || item.subtype === "") {
        txt = <text key="txr1" x={xt} y={yt}
                        fill="#333333" fontFamily="monospace" fontWeight={''} fontSize={9} transform={transformt}>
            {item.lcid===0 || item.lcid==="0"?"":item.lcid}
        </text>

        var schirm = <line
            x1={p2 + p32}
            y1={p1 - p4 + p32}
            x2={item.terminus ? p2 - p32 : p4}
            y2={p1 - p4 + p32}
            stroke={schirmcolor}
            strokeWidth={p4 - p32}
            strokeLinecap="round"/>;

        var mast = [];

        mast.push(<line
            key={'lx22'}
            x1={p1 - p4}
            y1={p1 - p4 + p32}
            x2={p2 + p32}
            y2={p1 - p4 + p32}
            stroke="#000000"
            strokeWidth={p32}
            strokeLinecap="round"/>);

        var lights1 = []
        lights1.push(<circle
            key={'asdsd'}
            cx={p2}
            cy={p1 - p4 + p32}
            r={(p4 - p32) / 3}
            fill={(itemstate === 0) ? sgred : sgoff}/>)
        if (!item.terminus) {
            lights1.push(<circle
                key={'asdssacd'}
                cx={p4}
                cy={p1 - p4 + p32}
                r={(p4 - p32) / 3}
                fill={(itemstate > 0) ? sggreen : sgoff}/>)
        }

        const lring = item.ori === 'east' ? '#9f9f9f' : '#3d88c9';

        const click = item.ori === 'east' ? 'e' : 'w';

        lights2.push(<circle key="c3"
                             cx={p1 - p4}
                             cy={p2}
                             r={p8}
                             fill={lring}/>);
        lights2.push(<circle key="c4"
                             cx={p1 - p4}
                             cy={p2}
                             r={(p4) / 2 - p32}
                             fill={(areaE||areaW) ? lringenter : '#575757'}/>);
        lights2.push(<circle key="c5"
                             cx={p1 - p4}
                             cy={p2}
                             r={(p4) / 2 - p16}
                             fill={select ? '#d5d3a4' : '#a93333'}/>);


        // Click area
        clickarea.push(
            <rect key={'rxx'} x={0} y={0} width={p1} height={p1} fillOpacity={0} onClick={() => doClick(click)}
                  onMouseEnter={() => areaEnter(true)} onMouseLeave={() => areaEnter(false)}/>
        )

        // rotate
        if (item.ori === "east") {
            transform = "rotate(180,0,0)";
        }
    } else if (item.subtype === "line") {

        line2 = null
        line3 = null

        const lring = item.ori === 'east' ? '#9f9f9f' : '#3d88c9';
        lights2.push(<circle key="c3"
                             cx={p2}
                             cy={p2}
                             r={p8}
                             fill={lring}/>);
        lights2.push(<circle key="c4"
                             cx={p2}
                             cy={p2}
                             r={(p4) / 2 - p32}
                             fill={(areaE||areaW) ? lringenter : '#575757'}/>);
        lights2.push(<circle key="c5"
                             cx={p2}
                             cy={p2}
                             r={(p4) / 2 - p16}
                             fill={select ? '#d5d3a4' : '#a93333'}/>);

        const path = 'M ' + (0) + ' ' + (0) + ' L ' + (0) + ' ' + (p4-p8) + ' L ' + (p8) + ' ' + (p8-p16) + ' Z'
        let transform_00 = item.ori === 'east' ? 'translate(' + (p8+p16) + ',' + (p8+p16) + ')' : 'translate(' + (p2+p4+p8-p16) + ',' + (p2+p4+p8-p16) + ') rotate(180, 0, 0)'
        lights2.push(
            <path key={'shunt_sg_east_sch_0'} d={path} fill={'#222222'} transform={transform_00}/>
        )


        // Click area
        clickarea.push(
            <rect key={'rxx'} x={0} y={0} width={p1} height={p1} fillOpacity={0} onClick={() => doClick('x')}
                  onMouseEnter={() => areaEnter(true)} onMouseLeave={() => areaEnter(false)}/>
        )

    } else if (item.subtype === "linedir") {
        line2 = null
        line3 = null

        const offcolor = '#363636'
        const rtyellow = '#fff44f'
        //const rtcolor = '#ff0000'

        let rt_is_set = item.lcid //&& item.lcid !== "x";

        let stbicolor_east = route_east ? rtyellow:offcolor
        let stbicolor_east_1 = (route_east && rt_is_set) ? rtyellow:offcolor

        let stbicolor_west = route_west ? rtyellow:offcolor
        let stbicolor_west_1 = (route_west && rt_is_set) ? rtyellow:offcolor


        if( item.ori_flipped) {
            let _tmp = stbicolor_east
            stbicolor_east = stbicolor_west
            stbicolor_west = _tmp

            _tmp = stbicolor_east_1
            stbicolor_east_1 = stbicolor_west_1
            stbicolor_west_1 = _tmp
        }


        const dx = 0 //p8
        const dy = 0 //p16+p32
        const path = 'M ' + (0+dx) + ' ' + (0+dy) + ' L ' + (0+dx) + ' ' + (p4-p8+dy) + ' L ' + (p4+p8+dx) + ' ' + (p8-p16+dy) + ' Z'

        let transform_00 = 'translate(' + (p16) + ',' + (p8+p16) + ')';
        let transform_03 = 'translate(' + (p2+p4+p8+p16) + ',' + (p2+p4+p16) + ') rotate(180,' + 0 + ',' + 0 + ') ';
        let transform_01 = 'translate(' + (p2+p16) + ',' + (p8+p16) + ')';
        let transform_02 = 'translate(' + (p2-p16) + ',' + (p2+p4+p16) + ') rotate(180,' + 0 + ',' + 0 + ') ';

        lights2.push(
            <path key={'shunt_sg_east_sch_0'} d={path} fill={stbicolor_east}  stroke={'#343434'} strokeWidth={0.4} transform={transform_00}/>
        )

        lights2.push(
            <path key={'shunt_sg_east_sch_1'} d={path} fill={stbicolor_east_1} stroke={'#343434'} strokeWidth={0.4} transform={transform_01}/>
        )

        lights2.push(
            <path key={'shunt_sg_east_sch_22'} d={path} fill={stbicolor_west} stroke={'#343434'} strokeWidth={0.4} transform={transform_03}/>
        )

        lights2.push(
            <path key={'shunt_sg_east_sch_33'} d={path} fill={stbicolor_west_1} stroke={'#343434'} strokeWidth={0.4} transform={transform_02}/>
        )

        lights2.push(bm_left({stroke: rtcolor}));
        lights2.push(bm_right({stroke: rtcolor}));

        // rotate
        //if (item.ori === "east") {
        //    transform = "rotate(180,0,0)";
        //}
    }


    // onClick={onClick}


    return (
        <PlIcon item={item} transform={transform}>
            {select}
            {line}
            {line2}
            {line3}
            {schirm}
            {mast}
            {lights1}
            {lights2}
            {txt}
            {searchbubble}
            {autonextbubble}
            {clickarea}
        </PlIcon>
    )
}

export default SgIcon
